import Titulo from "../../components/atoms/titles/Titulo";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import ConstantesTabla from "../../utils/ConstantesTabla";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./concursoPS.scss";
import Header from "../../components/molecules/header/Header";
import {
  getConcursosById,
  obtenerSolicitudPorCod,
} from "../../components/services/ConcursosService";
import ConsModSolicitudesF from "./ConsModSolicitudesF";
import ConsModSolicitudesL from "./ConsModSolicitudesL";
import Footer from "../../components/molecules/footer/Footer";
const ConsModSolicitudes = (object) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [datos, setDatos] = useState({
    adscripcion: "",
    vtipcnvo: "",
    descConv: "",
    borrador: "",
  });
  const [loadingSol, setLoadingSol] = useState(false);
  const [loadingCon, setLoadingCon] = useState(false);
  const columnas = [ConstantesTabla.columnasTablaAnexos];
  columnas.push({
    name: "Modificar",
    grow: 1.1,
    center: true,
    cell: (row) =>
      row.id === 1 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate("/anexoii_1")}
        ></i>
      ) : row.id === 3 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate("/anexoii_3")}
        ></i>
      ) : row.id === 4 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate("/anexoii_4")}
        ></i>
      ) : null,
  });
  useEffect(() => {
    getConcursosById(params.idCon).then((data) => {
      
      setDatos((prevState) => ({
        ...prevState,
        adscripcion: data.adscripcion,
        vtipcnvo: data.vtipcnvo,
        descConv: data.dconvocator
      }));
      setLoadingCon(true);
    });
    obtenerSolicitudPorCod(params.idSol).then((data) => {
      
      setDatos((prevState) => ({
        ...prevState,
        borrador: data.dSolicitud,
        xSolicitud: data.xSolicitud,
        nIdesol: data.nIdesol
      }));
      setLoadingSol(true);
    });
  }, [location.state, params.idCon, params.idSol]);
  
  return (
    <>
      <Header></Header>
      <div className="containerMod" role="main" data-landmark-index="4">
        {loadingCon ? (
          <>
            {" "}
            {/*<Titulo
              tipo={"tituloPagina"}
              titulo={"Consultar/Modificar Solicitud"}
            />*/}
            <h2 className="tituloPagina">Consultar/Modificar Solicitud</h2>
            <Titulo
              tipo={"tituloPagina"}
              titulo={
                datos.adscripcion === "F"
                  ? datos.vtipcnvo === "B"
                    ? <h2 className="tituloPagina">Concurso Puestos No Singularizados</h2>
                    : <h2 className="tituloPagina">Concurso Puestos Singularizados</h2>
                  : datos.adscripcion === "L"
                    ? <h2 className="tituloPagina">Traslado Personal Laboral</h2>
                    : <h2 className="tituloPagina">Concurso Puestos Singularizados</h2>
              }
            />
            <div className="titulos fondo">
              <div className="tit1">
                <Titulo
                  clases={""}
                  tipo="tituloPagina2"
                  titulo={"Convocatoria: "}
                />
              </div>
              <div className="contenidoTit1">
                <p className="">{datos.descConv}</p>
              </div>

              <div className="tit2">
                <Titulo
                  clases={""}
                  tipo="tituloPagina2"
                  titulo={"Borrador: "}
                />
              </div>
              <div className="contenidoTit2">
                <p className="">{datos.borrador}</p>
              </div>
            </div>
            <div className={"vistaAnexos"}>
              <div className="fondo pt-3" style={{ margin: "2.4rem" }}>
                <div className="container d-flex flex-column">
                  <i className="fa-solid fa-caret-right my-2">
                    <span className="text-black">
                      {" "}
                      Vaya realizando los siguientes pasos, cumplimentando los
                      modelos que sean necesarios.
                    </span>
                  </i>
                </div>
                {}
                {loadingSol ? (
                  <>
                    <div className="container tablaAnexos card">
                      {datos.adscripcion === "F" ? (
                        <ConsModSolicitudesF
                          xSolicitud={datos.xSolicitud}
                          codConcurso={params.idCon}
                          tipoConvocatoria={datos.vtipcnvo}
                          numSol={datos.nIdesol}
                        ></ConsModSolicitudesF>
                      ) : datos.adscripcion === "L" ? (
                        <ConsModSolicitudesL
                          xSolicitud={datos.xSolicitud}
                          codConcurso={params.idCon}
                          tipoConvocatoria={datos.vtipcnvo}
                          numSol={datos.nIdesol}
                        ></ConsModSolicitudesL>
                      ) : (
                        <>
                          <p className="rojo">Error al mostrar los Anexos</p>
                        </>
                      )}
                    </div>
                    <div className="btnVolver col-md-2 col-sm-3 col-4 mx-auto p-1 d-flex justify-content-center">
                      <button
                        id="volver"
                        className="btnRed rounded botonVolverConsMod py-1 mb-1"
                        type="button"
                        onClick={() => {
                          navigate(`/concurso/${params.idCon}`)
                        }}
                      >
                        <i className="fa-solid fa-rotate-left"></i> Volver
                      </button>
                    </div>
                  </>
                ) : (
                  <span>
                    <SpinnerCircle />
                  </span>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="error loadingConcurso rojo fs-4 pt-2 d-flex align-items-center justify-content-center flex-column my-auto w-200">
            <SpinnerCircle></SpinnerCircle>
          </div>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};

export default ConsModSolicitudes;
